import React from 'react';

import SetupDetail from './Setup';

const SetupPage = () =>
  <div>
    <SetupDetail />
  </div>

export default SetupPage;



// WEBPACK FOOTER //
// ./src/components/admin/SetupPage.jsx